export enum ECustomFilterType {
  external = 'external',
  manual = 'manual',
}

export interface IApiCustomFilterConfiguration {
  type: ECustomFilterType.external;
  widgetRequestId: number;
  dropdownIdPath: string;
  dropdownNamePath: string;
}

export interface IPredefinedCustomFilterValue {
  id: string;
  name: string;
}

export interface IPredefinedCustomFilterConfiguration {
  type: ECustomFilterType.manual;
  values: IPredefinedCustomFilterValue[];
}

export interface ICustomFilter {
  id: number;
  name: string;
  typeBasedConfiguration: IApiCustomFilterConfiguration | IPredefinedCustomFilterConfiguration;
}

export interface ICustomFilterAddPayload {
  name: string;
  typeBasedConfiguration: IApiCustomFilterConfiguration | IPredefinedCustomFilterConfiguration;
}

export interface ICustomFilterEditPayload {
  id: number;
  dto: ICustomFilterAddPayload;
}

export interface ICustomFilterAddEditDialogData {
  dialogTitle: string;
  submitButtonText: string;
  editData?: ICustomFilter;
}
